import { PlanType, UseTranslateType } from "../../../@types";

export enum AlertMessageConditions {
  NO_SAVED_PHARMACIES = 0,
  NO_SAVED_DRUGS = 1,
  ONE_SAVED_PHARMACY_STALE_ACCOUNT = 2,
  ONE_SAVED_PHARMACY = 3,
  STALE_ACCOUNT_PHARMACIES = 4,
  STALE_ACCOUNT_DRUGS = 5,
  NO_IN_NETWORK_SAVED_PHARMACIES = 6,
  NO_PREFERRED_SAVED_PHARMACIES = 7,
}

export enum AlertMessageHierarchyKeys {
  SUMMARY_PAGE__PHARMACY_SECTION,
  SUMMARY_PAGE__DRUG_SECTION,
  PLAN_DETAILS__PHARMACY_SECTION,
  PLAN_COMPARISON_TABLE,
  PLAN_COMPARISON_NETWORK_STATUS,
  IN_NETWORK_PHARMACY_FINDER,
}

/**
 * @type
 * for adding specific page context to help correctly render links in alert messages
 * @property planId - optional planId to construct in-network plan finder links
 * @property routerState - optional router state to help set back links and 'done' buttons used with 'nextRoute' in router state
 * @property planType - optional plan type to determine if alert should be active
 * @property isFromSummaryPage - optional controls summary page specific rules around visibility and links
 */
export type PageContext = {
  planId?: string;
  routerState?: unknown;
  planType?: PlanType;
  isFromSummaryPage?: boolean;
  // indicates if the plan in this PageContext has any preferred pharmacies or not
  planHasPreferredPharmacies?: boolean;
};

/**
 * @type
 * content and active status for displaying an alert message in the app
 * @property action - optional content for displaying a CTA button or link
 * @property active - is message currently valid and should display
 * @property body - content for displaying body of message
 * @property icon - optional status icon to display in alert
 * @property key - type of Alert Message
 * @property title - optional title for alert message
 */
export type AlertMessageType = {
  action:
    | ((t: UseTranslateType, pageContext?: PageContext) => JSX.Element)
    | undefined;
  active: boolean;
  body: (
    t: UseTranslateType,
    pageContext?: PageContext
  ) => JSX.Element | string;
  icon: JSX.Element | undefined;
  key: AlertMessageConditions;
  title: ((t: UseTranslateType) => string) | undefined;
};

/**
 * @type
 * Formatted version of the AlertMessage type with all of the phrase translations and interpolations completed
 */
export type FormattedAlertMessage = {
  action: JSX.Element | undefined;
  active: boolean;
  body: JSX.Element | string;
  icon: JSX.Element | undefined;
  key: AlertMessageConditions;
  title: string | undefined;
};

export type MessagesState = {
  messages: Record<AlertMessageConditions, AlertMessageType>;
};

export type FlattenedMessageState = {
  messages: AlertMessageType[];
};
